<template lang="pug">
.label(v-if="label" :for="name") {{ label }}
FormField(v-slot="$field" :name="name")
  DateInput(
    v-model="$field.value"
    :name="name"
    :class="$attrs.class"
    :id="$attrs.id"
    :disabled="$attrs.disabled ?? false"
    :showButtonBar="$attrs.showButtonBar || true"
    :manualInput="$attrs.manualInput || false"
    :placeholder="$attrs.placeholder"
  )
  Message(v-if="$field?.invalid && ($field?.touched || formSubmitted)" severity="error" size="small" variant="simple") {{ $field.error?.message }}
</template>

<script setup>
import { inject, ref } from 'vue'
import DateInput from "./DateInput.vue"
import { FormField } from '@primevue/forms';
import Message from 'primevue/message';

const formSubmitted = inject('appFormSubmitted', ref(false))

const props = defineProps({
  name:   { type: String, required: true },
  label:  { type: String, required: false },
})

defineOptions({inheritAttrs: false})
</script>
